import * as React from 'react';
import { useTranslation, Trans } from 'react-i18next';

// Components
import { InterpolatedFormCopy } from '../components/InterpolatedFormCopy';
import { PrimaryText } from '../../PrimaryText';

// i18n
import i18n from '../../../i18n';

// Types
import { ISurveyTargetPeriod } from '../../../types';

interface useFieldTranslationProps {
    key?: string;
    label?: string | React.ReactNode;
    translationNamespace?: string;
    formData?: Record<string, any>;
    noInterpolation?: boolean;
    hasMarkup?: boolean;
    targetPeriod?: ISurveyTargetPeriod;
}

export const useFieldTranslation = ({
    key,
    label = '',
    translationNamespace = 'questions',
    formData = {},
    noInterpolation,
    hasMarkup,
    targetPeriod
}: useFieldTranslationProps) => {
    const { t } = useTranslation();

    const Translation = React.useMemo(() => {
        // Cannot interpolate values if translation has markup which needs parsing
        if (hasMarkup) {
            return (
                <Trans
                    t={t}
                    i18nKey={key}
                    ns={translationNamespace}
                    components={{
                        strong: <strong />,
                        u: <u />,
                        highlight: <PrimaryText />,
                        i: <i />
                    }}
                />
            );
        }

        const copy = key ? t(key, { ns: translationNamespace, component: { strong: <strong /> } }) : label;

        return typeof copy === 'string' && !noInterpolation ? (
            <InterpolatedFormCopy copy={copy} data={formData} targetperiod={targetPeriod} />
        ) : (
            copy
        );
    }, [key, label, i18n?.language, formData]);

    return Translation;
};

export default useFieldTranslation;
